// src/components/Modal.jsx
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const Modal = ({ open, onClose, title, children, initialFocusSelector }) => {
  const overlayRef = useRef(null);

  // 🔒 Bloque le scroll du body quand la modale est ouverte
  useEffect(() => {
    if (!open) return;
    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = overflow; };
  }, [open]);

  // ⌨️ Fermer avec ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  // 🎯 Focus auto sur un champ si fourni
  useEffect(() => {
    if (!open || !initialFocusSelector) return;
    const el = document.querySelector(initialFocusSelector);
    if (el) el.focus();
  }, [open, initialFocusSelector]);

  if (!open) return null;

  // 🌌 Portal direct dans le <body> => aucun parent ni overflow ne peut la cacher
  return createPortal(
    <div
      className="modal-root"
      aria-modal="true"
      role="dialog"
      aria-labelledby="modal-title"
    >
      <div
        ref={overlayRef}
        className="modal-overlay fade-in"
        onClick={onClose}
      />
      <div
        className="modal-panel pop-in"
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <h3 id="modal-title" className="modal-title">
            {title}
          </h3>
        )}
        {children}
        <div className="modal-actions">
          <button className="btn" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
